import { FxIdWebFeaturesProfileUpdateMarketingEnabledRequest } from "@fxid/openapi-client";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import OpenApiClient from "../../../../packages/fxid-openapi-client/src/OpenApiClient.ts";

export const useUpdateUserMarketingMutation = (
	options?: Omit<
		UseMutationOptions<unknown, unknown, FxIdWebFeaturesProfileUpdateMarketingEnabledRequest>,
		"mutationFn"
	>
) => {
	return useMutation<unknown, unknown, FxIdWebFeaturesProfileUpdateMarketingEnabledRequest>({
		mutationFn: (vars) => OpenApiClient.Profile.fxIdWebFeaturesProfileUpdateMarketingEnabledEndpoint(vars),
		...options
	});
};
